export function randomNum(base, x) {
    return Math.floor((Math.random() * x) + base);
    }
